import React from 'react'

export default function Letter(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={'1em'}
            height={'1em'}
            viewBox="0 0 32 32"
            {...props}
        >
            <path d="M25 12h-5v2h5a1 1 0 0 1 1 1v2h-4a3.003 3.003 0 0 0-3 3v1a3.003 3.003 0 0 0 3 3h6v-9a3.003 3.003 0 0 0-3-3Zm-3 10a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h4v3ZM16 24h2L12 7h-2L4 24h2l1.694-5h6.613Zm-7.629-7 2.497-7.371h.266L13.63 17Z" />
            <path
                d="M0 0h32v32H0z"
                data-name="&lt;Transparent Rectangle&gt;"
                style={{
                    fill: 'none'
                }}
            />
        </svg>
    )
}

export function LetterBold(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={'1em'}
            height={'1em'}
            viewBox="0 0 32 32"
            {...props}
            fill="none"
            stroke="red"
            strokeWidth={0.6}
        >
            <path
                fill="red"
                d="M25 12h-5v2h5a1 1 0 0 1 1 1v2h-4a3.003 3.003 0 0 0-3 3v1a3.003 3.003 0 0 0 3 3h6v-9a3.003 3.003 0 0 0-3-3Zm-3 10a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h4v3ZM16 24h2L12 7h-2L4 24h2l1.694-5h6.613Zm-7.629-7 2.497-7.371h.266L13.63 17Z"
            />
        </svg>
    )
}
